<template>
  <!-- header (relative style) -->
  <header class="header-new">
    <div class="header-container">
      <!-- Right side - Logo and Categories -->
      <div class="header-right">
        <!-- Main Logo -->
        <router-link to="/" class="main-logo-link">
          <img src="../../assets/logo.png" alt="Logo" class="main-logo" />
        </router-link>

        <!-- Categories Dropdown -->
        <div class="categories-dropdown">
          <button class="categories-btn" @click="toggleCategories">
            <svg class="svg-icon" viewBox="0 0 20 20" width="20" height="20">
              <path fill="currentColor" d="M7.228,11.464H1.996c-0.723,0-1.308,0.587-1.308,1.309v5.232c0,0.722,0.585,1.308,1.308,1.308h5.232
                  c0.723,0,1.308-0.586,1.308-1.308v-5.232C8.536,12.051,7.95,11.464,7.228,11.464z M7.228,17.351c0,0.361-0.293,0.654-0.654,0.654
                  H2.649c-0.361,0-0.654-0.293-0.654-0.654v-3.924c0-0.361,0.292-0.654,0.654-0.654h3.924c0.361,0,0.654,0.293,0.654,0.654V17.351z
                  M17.692,11.464H12.46c-0.723,0-1.308,0.587-1.308,1.309v5.232c0,0.722,0.585,1.308,1.308,1.308h5.232
                  c0.722,0,1.308-0.586,1.308-1.308v-5.232C19,12.051,18.414,11.464,17.692,11.464z M17.692,17.351c0,0.361-0.293,0.654-0.654,0.654
                  h-3.924c-0.361,0-0.654-0.293-0.654-0.654v-3.924c0-0.361,0.293-0.654,0.654-0.654h3.924c0.361,0,0.654,0.293,0.654,0.654V17.351z
                  M7.228,1H1.996C1.273,1,0.688,1.585,0.688,2.308V7.54c0,0.723,0.585,1.308,1.308,1.308h5.232c0.723,0,1.308-0.585,1.308-1.308
                  V2.308C8.536,1.585,7.95,1,7.228,1z M7.228,6.886c0,0.361-0.293,0.654-0.654,0.654H2.649c-0.361,0-0.654-0.292-0.654-0.654V2.962
                  c0-0.361,0.292-0.654,0.654-0.654h3.924c0.361,0,0.654,0.292,0.654,0.654V6.886z M17.692,1H12.46c-0.723,0-1.308,0.585-1.308,1.308
                  V7.54c0,0.723,0.585,1.308,1.308,1.308h5.232C18.414,8.848,19,8.263,19,7.54V2.308C19,1.585,18.414,1,17.692,1z M17.692,6.886
                  c0,0.361-0.293,0.654-0.654,0.654h-3.924c-0.361,0-0.654-0.292-0.654-0.654V2.962c0-0.361,0.293-0.654,0.654-0.654h3.924
                  c0.361,0,0.654,0.292,0.654,0.654V6.886z"/>
            </svg>
            <span>التصنيفات</span>
          </button>
          <ul class="categories-menu" :class="{ 'show': showCategories }">
            <li v-for="(cat, indexo) in categorie" :key="indexo">
              <a @click="goCategories(cat)">{{ cat.name_ar }}</a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Center - Search Bar -->
      <div class="header-center">
        <form @submit.prevent="SearchData()" class="search-form">
          <input
            v-model="search"
            type="text"
            class="search-input"
            placeholder="بحث ..."
          />
          <button type="submit" class="search-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="M21 21l-4.35-4.35"/>
            </svg>
          </button>
        </form>
      </div>

      <!-- Left side - Zain Logo and Buttons -->
      <div class="header-left">
        <template v-if="!showHeader">
          <a @click="Subscrib()" class="header-btn header-btn-filled">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            <span>الاشتراك</span>
          </a>
          <router-link to="/Login" class="header-btn header-btn-outline">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M13.8 12H3"/>
            </svg>
            <span>الدخول</span>
          </router-link>
        </template>
        <template v-else>
          <router-link to="/Unsubscribes" class="header-btn header-btn-filled">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            <span>الغاء الاشتراك</span>
          </router-link>
          <router-link to="/user-profile" class="header-btn header-btn-outline">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
            <span>الملف الشخصي</span>
          </router-link>
        </template>

        <router-link to="/" class="zain-logo-link">
          <img src="../../assets/logoSvg.svg" alt="Zain" class="zain-logo" />
        </router-link>
      </div>
    </div>

    <!-- Mobile Menu Button -->
    <button type="button" class="mobile-menu-btn" :class="{ 'hidden': showMobileMenu }" @click.stop.prevent="toggleMobileMenu">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <!-- Mobile Menu Overlay -->
    <div class="mobile-overlay" :class="{ 'show': showMobileMenu }" @click="closeMobileMenu"></div>

    <!-- Mobile Menu -->
    <div class="mobile-menu" :class="{ 'show': showMobileMenu }">
      <!-- Menu Header -->
      <div class="mobile-menu-header">
        <img src="../../assets/logo.png" alt="Logo" class="mobile-menu-logo" />
        <button type="button" class="mobile-menu-close" @click="closeMobileMenu">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>

      <!-- Menu Items -->
      <nav class="mobile-menu-nav">
        <router-link to="/" class="mobile-menu-item" @click="closeMobileMenu">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
          <span>الصفحة الرئيسية</span>
        </router-link>

        <!-- Categories Section -->
        <div class="mobile-menu-section">
          <div class="mobile-menu-section-header" @click="toggleMobileCategories">
            <div class="mobile-menu-section-title">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="14" y="14" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
              </svg>
              <span>التصنيفات</span>
            </div>
            <svg class="chevron" :class="{ 'rotate': showMobileCategories }" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </div>
          <div class="mobile-menu-subcategories" :class="{ 'show': showMobileCategories }">
            <a v-for="(cat, indexo) in categorie" :key="indexo" @click="goCategories(cat); closeMobileMenu()" class="mobile-menu-subitem">
              {{ cat.name_ar }}
            </a>
          </div>
        </div>

        <template v-if="showHeader">
          <router-link to="/user-profile" class="mobile-menu-item" @click="closeMobileMenu">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
            <span>الملف الشخصي</span>
          </router-link>
          <router-link to="/Contacts" class="mobile-menu-item" @click="closeMobileMenu">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
            </svg>
            <span>اتصل بنا</span>
          </router-link>
          <a @click="closeMobileMenu" class="mobile-menu-item unsubscribe">
            <router-link to="/Unsubscribes" style="display: flex; align-items: center; gap: 12px; color: inherit; text-decoration: none; width: 100%;">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="15" y1="9" x2="9" y2="15"></line>
                <line x1="9" y1="9" x2="15" y2="15"></line>
              </svg>
              <span>الغاء الاشتراك</span>
            </router-link>
          </a>
        </template>
        <template v-else>
          <router-link to="/Login" class="mobile-menu-item" @click="closeMobileMenu">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
              <polyline points="10 17 15 12 10 7"></polyline>
              <line x1="15" y1="12" x2="3" y2="12"></line>
            </svg>
            <span>تسجيل الدخول</span>
          </router-link>
          <a @click="Subscrib(); closeMobileMenu()" class="mobile-menu-item subscribe-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="17 8 12 3 7 8"></polyline>
              <line x1="12" y1="3" x2="12" y2="15"></line>
            </svg>
            <span>إشتــرك الأن</span>
          </a>
        </template>
      </nav>

      <!-- Menu Footer -->
      <div class="mobile-menu-footer">
        <img src="../../assets/logoSvg.svg" alt="Zain" class="mobile-menu-zain" />
      </div>
    </div>
  </header>
  <!-- end header -->
</template>

<script>
import { HTTP } from '@/Api/http-common';
import { HTTPDSP } from '@/Api/http-dsp';
import config from '@/Api/config';
import { useRouter } from "vue-router"
import { useCookie } from 'vue-cookie-next'
import { onMounted, ref } from 'vue';
export default {
  name: "AppHeader",

  setup() {
    const router = useRouter();
    const cookie = useCookie();
    const showHeader = ref(false);
    const categorie = ref([]);
    const subscriptionStatus = ref(null);
    const search = ref([]);
    const showCategories = ref(false);
    const showMobileMenu = ref(false);
    const showMobileCategories = ref(false);

    onMounted(async () => {
      if (cookie.isCookieAvailable('msisdn') && cookie.isCookieAvailable('status')) {
        showHeader.value = true;
        try {
          const response = await HTTPDSP.get(`DSPCheckLogin.php?msisdn=${cookie.getCookie("msisdn")}`, {
            headers: { Authorization: config.authHeader },
          });
          const status = response.data?.status;
          const message = response.data?.message || "Unknown error";
          if (status == 1 && message == "Successful") {
            subscriptionStatus.value = "subscribed";
          } else if (status == 0 && message == "Subscribed but not active") {
            cookie.removeCookie('msisdn');
            cookie.removeCookie('status');
            subscriptionStatus.value = "Subscribed_but_not_active";
          } else if (status == 0 && message == "Not subscribed") {
            cookie.removeCookie('msisdn');
            cookie.removeCookie('status');
            cookie.removeCookie('minutes');
            subscriptionStatus.value = "not_subscribed";
          } else {
            console.warn("Unexpected status or message:", response.data);
            cookie.removeCookie('msisdn');
            cookie.removeCookie('status');
            cookie.removeCookie('minutes');
            subscriptionStatus.value = "unexpected_status";
          }
        } catch (error) {
          console.error('Error checking subscription:', error);
        }
      } else {
        showHeader.value = false;
      }

      // Fetch categories
      try {
        const res = await HTTP.get(`GetAllCategories.php`, {
          headers: { 'Authorization': config.authHeader },
        });
        categorie.value = Array.isArray(res.data?.Categories) ? res.data.Categories : [];
      } catch (err) {
        console.log(err);
      }

      // Close categories when clicking outside
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.categories-dropdown')) {
          showCategories.value = false;
        }
      });
    });

    const toggleCategories = () => {
      showCategories.value = !showCategories.value;
    };

    const toggleMobileMenu = () => {
      showMobileMenu.value = !showMobileMenu.value;
    };

    const closeMobileMenu = () => {
      showMobileMenu.value = false;
      showMobileCategories.value = false;
    };

    const toggleMobileCategories = () => {
      showMobileCategories.value = !showMobileCategories.value;
    };

    const goCategories = (cat) => {
      showCategories.value = false;
      if (cat.have_sub == 1) {
        router.push({ name: "audiobooks", params: { cat_id: cat.id, cat_name: cat.name_ar } });
      } else {
        router.push({ name: "Categories", params: { cat_id: cat.id, cat_name: cat.name_ar } });
      }
    };

    const Subscrib = () => {
      window.open("https://dsplp.sd.zain.com/af-lp/?p=2741755443", "_self");
    }

    const SearchData = () => {
      router.push({ name: "Search", params: { search_id: search.value } });
    }

    return {
      showHeader,
      categorie,
      Subscrib,
      subscriptionStatus,
      SearchData,
      search,
      goCategories,
      showCategories,
      toggleCategories,
      showMobileMenu,
      toggleMobileMenu,
      closeMobileMenu,
      showMobileCategories,
      toggleMobileCategories
    };
  },

  mounted() {
    let externalScript = document.createElement("script");
    externalScript.setAttribute("src", "/assets/js/main.js");
    document.head.appendChild(externalScript);
  },

};
</script>

<style scoped>
.header-new {
  background: linear-gradient(135deg, #0d4d5a 0%, #1a8a9a 50%, #2db3b3 100%);
  padding: 15px 0;
  position: relative;
  direction: rtl;
  min-height: 80px;
}

.header-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 10;
}

/* Left Side - Zain Logo and Buttons */
.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.zain-logo-link {
  display: flex;
  align-items: center;
}

.zain-logo {
  height: 40px;
  width: auto;
  filter: brightness(0) invert(1);
}

.header-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 25px;
  font-family: 'Zain_Regular', sans-serif;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  white-space: nowrap;
}

.header-btn-outline {
  background: transparent;
  border: 2px solid #fff;
  color: #fff;
}

.header-btn-outline:hover {
  background: rgba(255, 255, 255, 0.1);
}

.header-btn-filled {
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: #fff;
}

.header-btn-filled:hover {
  background: rgba(255, 255, 255, 0.25);
}

/* Center - Search Bar */
.header-center {
  flex: 1;
  max-width: 400px;
  margin: 0 30px;
}

.search-form {
  display: flex;
  align-items: center;
  background: #1a3a40;
  border-radius: 30px;
  padding: 5px 15px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.search-input {
  flex: 1;
  background: transparent;
  border: none;
  color: #fff;
  font-family: 'Zain_Regular', sans-serif;
  font-size: 14px;
  padding: 10px;
  outline: none;
  text-align: right;
}

.search-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.search-btn {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-btn:hover {
  color: #fff;
}

/* Right Side - Logo and Categories */
.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* Categories Dropdown */
.categories-dropdown {
  position: relative;
  z-index: 100;
}

.categories-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  color: #fff;
  font-family: 'Zain_Regular', sans-serif;
  font-size: 14px;
  cursor: pointer;
  padding: 10px 15px;
  border-radius: 8px;
  transition: background 0.3s ease;
}

.categories-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.categories-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: #1a3a40;
  border-radius: 12px;
  padding: 10px 0;
  min-width: 200px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s ease;
  z-index: 100;
  list-style: none;
  margin: 10px 0 0 0;
}

.categories-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.categories-menu li {
  padding: 0;
}

.categories-menu a {
  display: block;
  padding: 12px 20px;
  color: #fff;
  text-decoration: none;
  font-family: 'Zain_Regular', sans-serif;
  font-size: 14px;
  transition: background 0.3s ease;
  cursor: pointer;
  direction: rtl;
  text-align: right;
}

.categories-menu a:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* Main Logo */
.main-logo-link {
  display: flex;
  align-items: center;
  z-index: 10;
}

.main-logo {
  height: 50px;
  width: auto;
  display: block;
}

/* Mobile Menu Button */
.mobile-menu-btn {
  display: none;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 15px;
  z-index: 1000;
}

.mobile-menu-btn span {
  display: block;
  width: 25px;
  height: 3px;
  background: #fff;
  margin: 5px 0;
  border-radius: 2px;
  transition: all 0.3s ease;
}

.mobile-menu-btn:active span {
  background: #2db3b3;
}

.mobile-menu-btn.hidden {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

/* Mobile Overlay */
.mobile-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.mobile-overlay.show {
  opacity: 1;
  visibility: visible;
}

/* Mobile Menu */
.mobile-menu {
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  width: 300px;
  max-width: 85vw;
  height: 100vh;
  background: linear-gradient(180deg, #0d4d5a 0%, #1a3a40 100%);
  z-index: 999;
  direction: rtl;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  overflow-y: auto;
}

.mobile-menu.show {
  transform: translateX(0);
}

/* Menu Header */
.mobile-menu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.1);
}

.mobile-menu-logo {
  height: 45px;
  width: auto;
}

.mobile-menu-close {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: #fff;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mobile-menu-close:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* Menu Navigation */
.mobile-menu-nav {
  padding: 15px 0;
}

.mobile-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  color: #fff;
  text-decoration: none;
  font-family: 'Zain_Regular', sans-serif;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-right: 3px solid transparent;
}

.mobile-menu-item:hover,
.mobile-menu-item:active {
  background: rgba(255, 255, 255, 0.1);
  border-right-color: #2db3b3;
}

.mobile-menu-item svg {
  flex-shrink: 0;
  color: #2db3b3;
}

.mobile-menu-item.subscribe-btn {
  margin: 15px 20px;
  background: linear-gradient(135deg, #2db3b3 0%, #1a8a9a 100%);
  border-radius: 12px;
  justify-content: center;
  border-right: none;
}

.mobile-menu-item.subscribe-btn:hover {
  background: linear-gradient(135deg, #3cc9c9 0%, #1f9faf 100%);
}

.mobile-menu-item.subscribe-btn svg {
  color: #fff;
}

.mobile-menu-item.unsubscribe {
  color: rgba(255, 255, 255, 0.7);
}

/* Categories Section */
.mobile-menu-section {
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  margin: 10px 0;
}

.mobile-menu-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mobile-menu-section-header:hover {
  background: rgba(255, 255, 255, 0.05);
}

.mobile-menu-section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #fff;
  font-family: 'Zain_Regular', sans-serif;
  font-size: 16px;
}

.mobile-menu-section-title svg {
  color: #2db3b3;
}

.mobile-menu-section-header .chevron {
  color: rgba(255, 255, 255, 0.5);
  transition: transform 0.3s ease;
}

.mobile-menu-section-header .chevron.rotate {
  transform: rotate(180deg);
}

.mobile-menu-subcategories {
  max-height: 0;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.15);
  transition: max-height 0.3s ease;
}

.mobile-menu-subcategories.show {
  max-height: 400px;
  overflow-y: auto;
}

.mobile-menu-subitem {
  display: block;
  padding: 14px 50px 14px 20px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-family: 'Zain_Regular', sans-serif;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  text-align: right;
  direction: rtl;
}

.mobile-menu-subitem:last-child {
  border-bottom: none;
}

.mobile-menu-subitem:hover,
.mobile-menu-subitem:active {
  background: rgba(255, 255, 255, 0.1);
  color: #2db3b3;
  padding-right: 55px;
}

/* Menu Footer */
.mobile-menu-footer {
  padding: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: auto;
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.2);
}

.mobile-menu-zain {
  height: 30px;
  width: auto;
  filter: brightness(0) invert(1);
  opacity: 0.7;
}

/* Responsive */
@media (max-width: 1024px) {
  .header-container {
    padding: 0 20px;
  }

  .header-center {
    max-width: 300px;
    margin: 0 15px;
  }
}

@media (max-width: 768px) {
  .header-new {
    padding: 15px 0;
  }

  .header-container {
    justify-content: space-between;
    padding: 5px 15px;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .header-left .header-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    font-size: 0;
  }

  .header-left .header-btn span {
    display: none;
  }

  .header-left .header-btn svg {
    width: 18px;
    height: 18px;
    margin: 0;
  }

  .header-left .header-btn-outline {
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.3);
  }

  .header-left .header-btn-filled {
    background: #2db3b3;
    border: none;
  }

  .header-left .zain-logo-link {
    display: flex;
  }

  .zain-logo {
    height: 28px;
  }

  .header-center,
  .categories-dropdown {
    display: none;
  }

  .header-right {
    display: flex;
  }

  .mobile-menu-btn {
    display: block;
  }

  .mobile-overlay {
    display: block;
  }

  .mobile-menu {
    display: flex;
    flex-direction: column;
  }

  .main-logo-link {
    display: none !important;
  }
}

/* Desktop - ensure logo shows */
@media (min-width: 769px) {
  .main-logo-link {
    display: flex !important;
  }
}

/* Pointer cursor for clickable elements */
.pointer {
  cursor: pointer;
}
</style>
